import * as React from 'react';
import { Text, StackChildren } from '@doordash/design-language';
import { BillingTestId } from './testId';
import { TEAM_ACCOUNT_PAYMENT_METHOD } from '../../types/portal_data';
import PaymentCard from './PaymentCard/PaymentCard';
var SelfServeEnabled = function (_a) {
    var paymentMethod = _a.paymentMethod, paymentMethodCopy = _a.paymentMethodCopy;
    if (paymentMethod === TEAM_ACCOUNT_PAYMENT_METHOD.DEFAULT_CARD) {
        return React.createElement(PaymentCard, null);
    }
    if (paymentMethod === TEAM_ACCOUNT_PAYMENT_METHOD.INVOICING) {
        return (React.createElement(StackChildren, { size: StackChildren.Sizes.XxSmall, "data-testid": BillingTestId.SelfServeDisabledCopy },
            !!paymentMethodCopy && (React.createElement(Text, { "data-testid": BillingTestId.TeamAccountPayment, color: Text.Colors.TextSecondary }, paymentMethodCopy)),
            React.createElement(Text, { "data-testid": BillingTestId.ChangePayment, color: Text.Colors.TextSecondary }, "Please contact your DoorDash representative to change your account\u2019s payment method.")));
    }
    return null;
};
export default SelfServeEnabled;
